import { useSelector } from "react-redux";
import { filterSelector } from "../redux/slicers/filters/filterSlicer";

export const useFilterList = ({ type }) => {
  const { filterData } = useSelector(filterSelector);

  const filters = filterData?.results || [];

  if (!type) return filters;

  return {
    filterList: filters.filter(f => f.type === type),
  }
}